import axios from 'axios';

export const state = {
  accountCreations: [],
  loading: false,
};

export const mutations = {
  setAccountCreations(context, accountCreations) {
    context.accountCreations = accountCreations;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getAccountCreations({ commit, rootState }) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const accountCreations = await axios.get(`${window.BASE_API.BAADER}/account-creation`, options)
        .then(response => response.data);

      commit('setAccountCreations', accountCreations);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
  async createBaaderAccount(context, data) {
    return axios
      .post(`${window.BASE_API.BAADER}/account-creation`, data)
      .catch(error => Promise.reject(error));
  },
};

const accountCreationsStore = {
  state,
  mutations,
  actions,
};

export default accountCreationsStore;



// WEBPACK FOOTER //
// ./src/store/baader/accountCreationsStore.js